import { render, staticRenderFns } from "./ModalStockMovements.vue?vue&type=template&id=14cefbd2"
import script from "./ModalStockMovements.vue?vue&type=script&lang=js"
export * from "./ModalStockMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports